<template>
  <div v-if="album">
    <v-container fluid class="pa-0">
      <v-container class="py-3">
        <v-row no-gutters>
          <v-col
            :class="{ 'mb-4': $vuetify.breakpoint.xsOnly }"
            md="6"
            class="pa-0"
          >
            <v-row no-gutters>
              <div>
                <client-only>
                  <vue-goodshare-facebook
                    :page_url="
                      `https://100asa.com/albums/${album.id}/${album.slug}/`
                    "
                    :page_image="album.thumbnail"
                    :page_title="album.title"
                    :page_description="album.description"
                    :hashtag="album.tags.toString()"
                    has_icon
                  />
                  <vue-goodshare-twitter
                    :page_url="
                      `https://100asa.com/albums/${album.id}/${album.slug}/`
                    "
                    :page_image="album.thumbnail"
                    :page_title="album.title"
                    :page_description="album.description"
                    :hashtag="album.tags.toString()"
                    has_icon
                  />
                  <vue-goodshare-vkontakte
                    :page_url="
                      `https://100asa.com/albums/${album.id}/${album.slug}/`
                    "
                    :page_image="album.thumbnail"
                    :page_title="album.title"
                    :page_description="album.description"
                    :hashtag="album.tags.toString()"
                    has_icon
                  />
                  <vue-goodshare-linkedin
                    :page_url="
                      `https://100asa.com/albums/${album.id}/${album.slug}/`
                    "
                    :page_image="album.thumbnail"
                    :page_title="album.title"
                    :page_description="album.description"
                    :hashtag="album.tags.toString()"
                    has_icon
                  />
                  <vue-goodshare-pinterest
                    :page_url="
                      `https://100asa.com/albums/${album.id}/${album.slug}/`
                    "
                    :page_image="album.thumbnail"
                    :page_title="album.title"
                    :page_description="album.description"
                    :hashtag="album.tags.toString()"
                    has_icon
                  />
                  <vue-goodshare-reddit
                    :page_url="
                      `https://100asa.com/albums/${album.id}/${album.slug}/`
                    "
                    :page_image="album.thumbnail"
                    :page_title="album.title"
                    :page_description="album.description"
                    :hashtag="album.tags.toString()"
                    has_icon
                  />
                </client-only>
              </div>
            </v-row>
          </v-col>
          <v-col cols="12" md="6" class="pa-0 text-right" align-self="center">
            <template v-if="me && me.id === owner.id">
              <v-tooltip v-if="me" bottom>
                <template #activator="{ on }">
                  <v-btn
                    class="ml-4"
                    fab
                    depressed
                    outlined
                    small
                    v-on="on"
                    @click="editAlbum(album)"
                  >
                    <v-icon dark small>
                      fal fa-edit
                    </v-icon>
                  </v-btn>
                </template>
                <span>Edit album</span>
              </v-tooltip>
              <v-tooltip v-if="me" bottom>
                <template #activator="{ on }">
                  <v-btn
                    class="ml-4"
                    fab
                    depressed
                    outlined
                    small
                    v-on="on"
                    @click="manageAlbumPhotos(album)"
                  >
                    <v-icon dark small>
                      fal fa-images
                    </v-icon>
                  </v-btn>
                </template>
                <span>Manage album photos</span>
              </v-tooltip>
            </template>
            <span>
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-btn
                    :disabled="likeAlbumBusy"
                    :loading="likeAlbumBusy"
                    :outlined="!info || !info.likedAlready"
                    class="ml-4"
                    fab
                    depressed
                    small
                    v-on="on"
                    @click="likeAlbum(info && info.likedAlready ? -1 : 1)"
                  >
                    <div>
                      <v-icon dark small
                        >{{
                          info && info.likedAlready ? 'fas' : 'fal'
                        }}
                        fa-heart</v-icon
                      >
                    </div>
                  </v-btn>
                  <span class="ml-2">
                    {{ album.numberOfLikes }}
                  </span>
                </template>
                <span>
                  {{ info && info.likedAlready ? 'Unlike' : 'Like' }} this album
                </span>
              </v-tooltip>
            </span>
            <v-tooltip v-if="me" bottom>
              <template #activator="{ on }">
                <v-btn
                  class="ml-4"
                  fab
                  depressed
                  outlined
                  small
                  v-on="on"
                  @click="reportAlbum()"
                >
                  <v-icon dark small>fal fa-flag</v-icon>
                </v-btn>
              </template>
              <span>Report this album</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <Create-edit-album-dialog v-if="me" :me="me" :public-view="true" />
    <Manage-photos-dialog v-if="me" :public-view="true" />
  </div>
</template>

<script>
import { displayConfirm } from '@/utils/swal'
import { EventBus } from '@/plugins/event-bus'

export default {
  name: 'AlbumActions',
  components: {
    CreateEditAlbumDialog: () => import('@/components/albums/CreateEditAlbumDialog.vue'),
    ManagePhotosDialog: () => import('@/components/albums/ManagePhotosDialog.vue')
  },
  props: {
    me: {
      type: [Object, Boolean],
      default: () => {}
    },
    album: {
      type: Object,
      default: () => {}
    },
    info: {
      type: Object,
      default: () => {}
    },
    owner: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      likeAlbumBusy: false
    }
  },
  methods: {
    editAlbum(album) {
      this.$store.dispatch('albums/setEditMode', true)
      this.$store.dispatch('albums/setEditAlbum', album)
      this.$store.dispatch('albums/setCreateEditAlbumDialog', true)
    },
    manageAlbumPhotos(album) {
      this.$store.dispatch('albums/setManageAlbumDialog', album)
    },
    async likeAlbum(value) {
      if (!this.me) {
        EventBus.$emit('snackbar', {
          text: 'You need to log in to like this album',
          color: 'info'
        })
      } else if (this.me.id === this.owner.id) {
        EventBus.$emit('snackbar', {
          text: 'You cannot like your own albums',
          color: 'info'
        })
      } else {
        const data = {
          value,
          id: this.album.id
        }
        try {
          this.likeAlbumBusy = true
          await this.$store.dispatch('albums/likeAlbum', data)
          await this.$auth.fetchUser()
        } catch (error) {
          this.$asa.appInsights('Comp: galleries/album/Actions.vue - method: likeAlbum', error)
        } finally {
          this.likeAlbumBusy = false
        }
      }
    },
    reportAlbum() {
      displayConfirm(
        'You are going to report this album because you think it contains one of the following: porn, racism or offensive content. By clicking continue you will be flagging this photo to the admin attention.',
        async result => {
          if (result.isConfirmed) {
            try {
              await this.$store.dispatch('albums/reportAlbum', this.album.id)
              EventBus.$emit('snackbar', {
                text: 'The album has been successfully reported',
                color: 'success'
              })
            } catch (error) {
              this.$asa.appInsights('Comp: galleries/album/Actions.vue - method: reportAlbum', error)
            }
          }
        }
      )
    }
  }
}
</script>
